<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import { isMobile } from "@/utils/common.js";

export default {
  name: "app",
  data() {
    return {
      isPhone: false,
      // msg: 'Welcome to your prerender-spa-plugin vue-cli 3 demo app!',
    };
  },
  created() {},
  watch: {
    $route: "getPath",
  },
  methods: {
    getPath() {
      //
    },
  },
};
</script>

<style lang="scss"  >
@import "./common/css/global.css";
@import "./common/css/font-awsome/css/font-awesome.min.css";
#app {
  height: 100%;
  width: 100%;
}
.content{
  >p{
    >p{
      font-size: 16px;
      color: #4d4f53;
      line-height: 30px;
      text-indent: 30px;
    }
  }
}
.ql-align-justify{
  font-size: 16px;
  // color: #4d4f53;
  line-height: 30px;
  text-indent: 30px;
  margin-bottom: 20px;
}
@media screen and (max-width: 768px) {
  * {
    // border: 1px solid red;
  }
  .wrap {
    width: 100% !important;
    // flex-wrap: wrap;
  }
}
@media only screen and (max-width: 767px) {
  .hidden-xs-only {
    display: none !important;
  }
}
@media only screen and (min-width: 768px) {
  .hidden-sm-and-up {
    display: none !important;
  }
}
@media only screen and (min-width: 768px) and (max-width: 991px) {
  .hidden-sm-only {
    display: none !important;
  }
}
@media only screen and (max-width: 991px) {
  .hidden-sm-and-down {
    display: none !important;
  }
}
@media only screen and (min-width: 992px) {
  .hidden-md-and-up {
    display: none !important;
  }
}
@media only screen and (min-width: 992px) and (max-width: 1199px) {
  .hidden-md-only {
    display: none !important;
  }
}
@media only screen and (max-width: 1199px) {
  .hidden-md-and-down {
    display: none !important;
  }
}
@media only screen and (min-width: 1200px) {
  .hidden-lg-and-up {
    display: none !important;
  }
}
@media only screen and (min-width: 1200px) and (max-width: 1919px) {
  .hidden-lg-only {
    display: none !important;
  }
}
@media only screen and (max-width: 1919px) {
  .hidden-lg-and-down {
    display: none !important;
  }
}
@media only screen and (min-width: 1920px) {
  .hidden-xl-only {
    display: none !important;
  }
}
</style>
